import { useCallback, useState } from "react";
import { useTranslation } from "react-i18next";
import { VocService } from "@/services/voc/voc.service";
import { downloadCsv } from "@/utils/csv";
import { showError } from "@/utils/notification";
import { useWorkspaces } from "./useWorkspaces";

export const useDownloadSearchResult = () => {
  const { t } = useTranslation("voiceek_ui");
  const [isDownloading, setIsDownloading] = useState(false);
  const { sessionCurrentWorkspaceId } = useWorkspaces();

  const handleDownload = useCallback(async (keyword: string) => {
    if (!sessionCurrentWorkspaceId || !keyword.trim()) return;

    setIsDownloading(true);
    try {
      const blob = await VocService.downloadSearchResult(sessionCurrentWorkspaceId, keyword);
      const sanitizedKeyword = keyword.trim().replaceAll(/[ \u3000\r\n]/g, "_");
      downloadCsv(blob, `${sanitizedKeyword}.csv`);
    } catch (error) {
      console.error(error);
      showError(t("voc.search.download.error"));
    } finally {
      setIsDownloading(false);
    }
  }, [sessionCurrentWorkspaceId, t]);

  return { handleDownload, isDownloading };
};
